<template>
  <div class="flex-col pdlr-12" style="height: 100%">
    <div style="flex: 1; overflow: auto" ref="table_body_element">
      <table>
        <tr class="table-title">
          <th
            v-for="(column, index) in columns"
            :key="index"
            :style="{ minWidth: column.width + 'px' }"
            style="padding: 0px 4px"
          >
            <span class="content">{{ column.title }}</span>
            <span style="float: right; width: 0">
              <span class="th-drag" @mousedown="handleMouseDown(column)" @mouseup="handleMouseUp"></span>
            </span>
          </th>
        </tr>
        <tr v-for="(row, index) in data" :key="index" class="tbody-tr">
          <td v-for="(column, index) in columns" :key="index" class="tbody-td">{{ row[column.title] }}</td>
        </tr>
      </table>
    </div>
    <div class="flex sql">
      <div class="sql-info" v-if="showSQL">
        <a-tag class="sql-content" :title="result.sql" @click="clickSql(result.sql)">{{ result.sql }}</a-tag>
        <a-popover>
          <template slot="content">
            <span style="white-space: pre-wrap">执行时间：{{ timestamp2Date(result.startTime) }}</span
            ><br />
            <span style="white-space: pre-wrap">结束时间：{{ timestamp2Date(result.endTime) }}</span>
          </template>
          <span>{{ result.execTime }}ms ( 执行 {{ result.escapeTime }} ms )</span>
        </a-popover>
      </div>
      <div class="sql-info" v-else></div>
      <a-pagination
        v-model="pageNo"
        :pageSize.sync="pageSize"
        :total="dataSource.length"
        size="small"
        class="mgtb-4"
        :show-total="(total) => `共 ${total} 行`"
        show-less-items
        show-size-changer
      />
    </div>
  </div>
</template>

<script>
import { timestamp2Date } from '@/utils/util'
export default {
  name: 'TabPaneResultTable',
  components: {},
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    result: {
      type: Object,
      default: () => {},
    },
    showSQL: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    columns: {
      immediate: true,
      handler: function () {
        this.pageNo = 1
        this.pageSize = 10
        if (this.$refs.table_body_element) {
          this.$refs.table_body_element.scrollTop = 0
          this.$refs.table_body_element.scrollLeft = 0
        }
      },
    },
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
    }
  },
  computed: {
    data() {
      return this.dataSource.slice((this.pageNo - 1) * this.pageSize, this.pageNo * this.pageSize)
    },
  },
  methods: {
    timestamp2Date,
    handleMouseDown(column) {
      this.currentColumn = column
      document.addEventListener('mousemove', this.handleMouseMove)
      document.addEventListener('mouseup', this.handleMouseUp)
      document.querySelector('body').style.cursor = 'col-resize'
    },
    // 松开时取消所有监听
    handleMouseUp() {
      document.removeEventListener('mousemove', this.handleMouseMove)
      document.removeEventListener('mouseup', this.handleMouseUp)
      document.querySelector('body').style.cursor = 'default'
    },
    // 移动时的处理
    handleMouseMove(e) {
      const moveDistance = e.movementX
      var width = this.currentColumn.width
      if (width + moveDistance < 10) {
        this.currentColumn.width = 0
        return
      } else {
        this.currentColumn.width += moveDistance
      }
    },
    clickSql(sql) {
      this.$emit('clickSql', sql)
    },
  },
}
</script>

<style lang="less" scoped>
th,
td {
  border: 1px solid #e8e8e8;
  padding: 4px;
}
th {
  padding: 0;
  .content {
    padding: 4px;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.th-drag {
  float: right;
  transform: translateX(4px);
  width: 8px;
  height: 30px;
  cursor: col-resize;
}
table tbody {
  display: block;
  overflow-y: auto;
  height: 270px;
}
.table-title {
  position: sticky;
  top: 0;
  background: #fafafa;
}
.tbody-tr {
  &:hover {
    background: #e6f7ff;
  }
  background: #fff;
}
.tbody-td {
  padding: 2px 8px;
  white-space: pre-wrap;
}

.sql {
  white-space: pre-wrap;
  color: #999aaa;
  text-overflow: ellipsis;
}

.sql-info {
  display: flex;
  align-items: center;
  flex: 1;
}
.sql-content {
  white-space: pre-wrap;
  overflow: hidden;
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 11px;
  color: #999aaa;
  cursor: pointer;
}
</style>